import PupilsRepository from '@app/api/repositories/pupils-repository'
import { IFile } from '@app/interfaces/files'
import { IPupil } from '@app/interfaces/pupil/pupils'
import ModalFooter from '@app/shared/modal-footer/modal-footer'
import { openNotificationWithIcon } from '@app/shared/notification/notification'
import { refreshOrganizationPupils } from '@app/store/actions/organization-pupils-actions'
import { updatePupil } from '@app/store/actions/pupils-actions'
import { Button, Form, Modal, Spin } from 'antd'
import { AxiosResponse } from 'axios'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import deleteImagePng from '@assets/images/delete.png'

interface props {
  pupil: IPupil
  avatar: IFile
  additionalValues?: {
    organizationId?: number
    groupId?: number
  }
  iconTrigger?: boolean
}

const RemoveAvatarForm: React.FC<props> = ({
  pupil,
  avatar,
  additionalValues,
  iconTrigger,
}) => {
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false)
  const [visible, setVisible] = useState<boolean>(false)
  const [form] = Form.useForm()
  const [t, i18n] = useTranslation()

  const showModal = () => {
    setVisible(true)
  }
  const hideModal = () => {
    setVisible(false)
    form.resetFields()
  }
  const dispatch = useDispatch()
  const onFinish = async (values: any) => {
    const newValues = {
      id: pupil.id,
      fileId: null,
      ...(additionalValues ? additionalValues : {}),
    }
    setConfirmLoading(true)
    const avatarApi = PupilsRepository.partialUpdate
    await avatarApi(newValues)
      .then((response: AxiosResponse<IPupil>) => {
        if (response.status === 200) {
          dispatch(updatePupil(response.data))
          openNotificationWithIcon('success', t('success.updated'))
          dispatch(refreshOrganizationPupils())
          setConfirmLoading(false)
        }
        hideModal()
      })
      .catch(() => {
        setConfirmLoading(false)
        openNotificationWithIcon('error', t('errors.error'))
      })
  }

  return (
    <React.Fragment>
      {iconTrigger ? (
        <Button
          onClick={showModal}
          type="text"
          icon={
            <img
              src={deleteImagePng}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
              alt=""
            />
          }
          size={'large'}
        />
      ) : (
        <Button
          icon={
            <img
              src={deleteImagePng}
              style={{
                width: '18px',
                height: 'auto',
                objectFit: 'contain',
                marginRight: '4px',
              }}
              alt=""
            />
          }
          onClick={showModal}
          size={'small'}
          type={'dashed'}>
          {t('users.removeAvatar')}
        </Button>
      )}

      <Modal
        open={visible}
        title={t('users.removeAvatar')}
        onCancel={confirmLoading ? undefined : hideModal}
        width={400}
        confirmLoading={confirmLoading}
        footer={[
          <React.Fragment key={1}>
            <ModalFooter
              confirm={confirmLoading}
              onCancel={hideModal}
              onSubmit={form.submit}
              remove={true}
            />
          </React.Fragment>,
        ]}>
        <Spin spinning={confirmLoading}>
          <Form form={form} onFinish={onFinish} layout={'vertical'}>
            <Form.Item>
              <div>{t('users.removeAccept')}</div>
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    </React.Fragment>
  )
}
export default RemoveAvatarForm
